// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"8bde11e1446e7697","5130":"6fb9c09cd569fc9f"}[chunkId] + ".css";
};